import React from "react";
import WebSkyLayout from "./WebSkyLayout";

const FavouriteSkyWeb = () => {
  return (
    <WebSkyLayout>
      {" "}
      <div id="centerColumn" className="col-center">
        <div id="overWrap" className="over-wrap" style={{}}>
          <div className="kv-wrap" style={{ display: "none" }}>
            <a>
              <img src="https://statics3.e2betms.xyz/images/kv/KV.jpg" alt />
            </a>
          </div>
        
          <div id="multiMarketsWrap" style={{}}>
            <h2 id="header">Multi Markets</h2>
            <p id="noMultiMarkets" style={{}}>
              There are currently no followed multi markets.
            </p>
          </div>
        </div>
      </div>
    </WebSkyLayout>
  );
};

export default FavouriteSkyWeb;
